/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-16 15:03:06
 * @Descripttion:
 */


import { POST } from '../assets/js/utils'
import qs from "qs"
const URL = {
    CityList:'/branch/getCityList',
    AreaList:'/branch/getAreaList',
    ShopList:'/branch/getShopList',
    Post:'/relay/post',   // 获取剩余名额
    GetPost:'/relay/get',   // 透传
}

function GetCityList(pars){
    return POST(URL.CityList,pars)
}
function GetAreaList(pars){
    return POST(URL.AreaList,pars)
}
function GetShopList(pars){
    return POST(URL.ShopList,pars)
}
function GetPost(pars = {}){
    return POST(URL.Post,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetPostGet(pars) {
    // return POST(URL.GetPost, pars)
    return POST(URL.GetPost, qs.stringify(pars), 1, "application/x-www-form-urlencoded")
}
export {
    GetAreaList, GetShopList, GetCityList, GetPost, GetPostGet
}